import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { PRESS, PRESS_IMAGES } from '../data/press';

export async function generateImagePack() {
  const zip = new JSZip();
  const folder = zip.folder('ASH-Press-Image-Pack');

  // README
  const readme = [
    'ASH — THE WITCH TRIALS OF DRUDENHAUS',
    'PRESS IMAGE PACK',
    '',
    'A COLAB Theatre production.',
    'Address: 169a Borough High Street, London SE1 1HR',
    'Season: Halloween 2026',
    '',
    'Writer, Director & Performer: Bertie Watkins',
    '',
    'PRESS CONTACT',
    `  Name : ${PRESS.press.name}`,
    `  Email: ${PRESS.press.email}`,
    `  Phone: ${PRESS.press.phone}`,
    `  Web  : ${PRESS.press.web}`,
    '',
    'IMAGE CAPTIONS',
    ...PRESS_IMAGES.map(
      (img, i) => `  ${String(i + 1).padStart(2, '0')}. ${img.file.split('/').pop()}\n      — ${img.caption}`
    ),
    '',
    'All images © Alex Walton for COLAB Theatre. Free to use for editorial',
    'coverage of ASH — The Witch Trials of Drudenhaus.',
    'Please credit "Alex Walton for COLAB Theatre".',
    ''
  ].join('\n');
  folder.file('README.txt', readme);

  // Captions file
  folder.file(
    'captions.txt',
    PRESS_IMAGES.map(
      (img) => `${img.file.split('/').pop()}\n${img.caption}\n`
    ).join('\n')
  );

  // Fetch each image and add to the zip
  await Promise.all(
    PRESS_IMAGES.map(async (img) => {
      const res = await fetch(img.file);
      const blob = await res.blob();
      folder.file(img.file.split('/').pop(), blob);
    })
  );

  // Also bundle the COLAB logo files
  try {
    const logoRes = await fetch('/ash/colab-logo.jpg');
    if (logoRes.ok) {
      folder.file('colab-logo.jpg', await logoRes.blob());
    }
  } catch (e) {
    // silent
  }

  const content = await zip.generateAsync({ type: 'blob' });
  saveAs(content, 'ASH-Press-Image-Pack.zip');
}
